import React from "react";

import Navbar from "./Navbar";
import EkgList from "./EkgList";

const Layout = () => {
  return (
    <div>
      <Navbar></Navbar>
      <EkgList></EkgList>
    </div>
  );
};

export default Layout;
